export default "__VITE_ASSET__3e4aeeff__"